import { organizationFlags, organizationFlagsEnum } from "helpers/enums";
import { isTechSupport } from "helpers/hiddenData";
import { flagVal } from "helpers/system";
import React, { useEffect, useState } from "react";
import { getOrderNotificationOption } from "sources/profile/user";
import TechSupportChat from "./chat";
import { OPEN_TECH_SUPPORT_CHAT_EVENT } from "./events";

const suitableOrdersFlagVal = flagVal(organizationFlags, organizationFlagsEnum.SuitableOrders);

const RELEASE_LOGS_PAGE = "https://cargorun.omnidesk.ru/knowledge_base/category/67612";

const TechSupportWidgets = (props) => {
    const [needOpenJivo, setNeedOpenJivo] = useState(false);
    const [internalTechSupportChatOpened, setInternalTechSupportChatOpened] = useState(false);

    const { jivoChatScriptUrl, organization } = props;
    const techSupportChatOpened =
        typeof props.techSupportChatOpened === "boolean" ? props.techSupportChatOpened : internalTechSupportChatOpened;
    const setTechSupportChatOpened = props.setTechSupportChatOpened ?? setInternalTechSupportChatOpened;

    const suitableOrdersEnabled = (organization.intFlags & suitableOrdersFlagVal) === suitableOrdersFlagVal;

    useEffect(() => {
        function addAsyncItem(t) {
            return function () {
                window.carrotquestasync.push(t, arguments);
            };
        }
        if (typeof window.carrotquest === "undefined") {
            const carrotQuestScript = document.createElement("script");
            carrotQuestScript.type = "text/javascript";
            carrotQuestScript.async = !0;
            carrotQuestScript.src = "https://cdn.carrotquest.app/api.min.js";
            document.head.appendChild(carrotQuestScript);
            window.carrotquest = {};
            window.carrotquestasync = [];
            window.carrotquest.settings = {};
            [
                "connect",
                "track",
                "identify",
                "auth",
                "onReady",
                "addCallback",
                "removeCallback",
                "trackMessageInteraction",
            ].forEach((item) => {
                window.carrotquest[item] = addAsyncItem(item);
            });
        }

        window.carrotquest.connect("51960-4ec6e21f7a68c94405be595f33");
        const { profile, roles } = props;

        window.carrotquest.identify({
            $name: `${profile.firstName} ${profile.lastName}`,
            $email: profile.email,
            $phone: `${profile.phone}`,
            Компания: profile.organizationName,
            Система: "CR Логистика",
            "Менеджер транспортной компании": roles.isTruckingOrganizationManager,
            "Администратор транспортной компании": roles.isTruckingOrganizationAdmin,
            "Главный логист": roles.isTruckingOrganizationHeadLogist,
        });
        const { email, fullName, phoneNumber } = profile;

        if (jivoChatScriptUrl && suitableOrdersEnabled) {
            const jivoScript = document.createElement("script");
            jivoScript.type = "text/javascript";
            jivoScript.async = !0;
            jivoScript.src = jivoChatScriptUrl;
            document.head.appendChild(jivoScript);

            window.jivo_onLoadCallback = function () {
                window.jivo_api.setContactInfo({
                    name: fullName,
                    email,
                    phone: phoneNumber,
                });
                getOrderNotificationOption().then(({ hasSuitableOrdersToSend, userJivoChatToken }) => {
                    window.jivo_api.setUserToken(userJivoChatToken);
                    if (hasSuitableOrdersToSend) {
                        window.jivo_api.sendMessage(`start ${Date.now()}`);
                    }
                });
                if (needOpenJivo) {
                    window.jivo_api.open();
                }
            };
        }
    }, []);

    useEffect(() => {
        const openTechSupportChat = () => setTechSupportChatOpened(true);

        window.addEventListener(OPEN_TECH_SUPPORT_CHAT_EVENT, openTechSupportChat);
        return () => window.removeEventListener(OPEN_TECH_SUPPORT_CHAT_EVENT, openTechSupportChat);
    }, [setTechSupportChatOpened]);

    const showWidget = () => {
        window.open("https://cargorun.omnidesk.ru/knowledge_base", "_blank").focus();
    };

    const showSystemUpdates = () => window.open(RELEASE_LOGS_PAGE, "_blank").focus();

    const openJivo = () => {
        setNeedOpenJivo(true);
        window.jivo_api?.open();
    };

    return (
        <>
            {jivoChatScriptUrl && suitableOrdersEnabled && (
                <div className="jivo-btn" onClick={openJivo}>
                    <i className="icon-uEAB5-truck-cost" />
                    Рекомендованные заказы
                </div>
            )}
            <div className="omnidesk-email-widget--container">
                <div className="omnidesk-email-widget">
                    <div
                        className="omnidesk-email-widget--item omnidesk-email-widget--knowledge-base"
                        title="База знаний"
                        onClick={showWidget}
                    />
                    {!isTechSupport() && (
                        <div
                            className="omnidesk-email-widget--item omnidesk-email-widget--chat"
                            onClick={() => setTechSupportChatOpened(!techSupportChatOpened)}
                        />
                    )}
                    <div
                        className="omnidesk-email-widget--item omnidesk-email-widget--fire"
                        title="Обновления системы"
                        onClick={showSystemUpdates}
                    />
                </div>
            </div>
            <TechSupportChat
                profile={props.profile}
                opened={techSupportChatOpened}
                setOpened={setTechSupportChatOpened}
            />
        </>
    );
};

export default TechSupportWidgets;
